/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.pad-start.js";
import 'dayjs/locale/zh-cn';
import weekYear from 'dayjs/plugin/weekYear';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend(weekYear);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export default defineComponent({
  name: 'CDateHeader',
  props: {
    type: {
      type: Number,
      default: 0
    },
    showDate: {
      type: Boolean,
      default: true
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '报表周期'
    },
    disabledDate: {
      type: String,
      default: 'disabledFuture'
    },
    showBtn: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '切换至表格'
    }
  },
  emits: ['switch', 'confirm-date'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    dayjs.locale('zh-cn', {
      weekStart: 1
    });
    var formatDateTime = function formatDateTime(date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    };
    var times = ref([new Date(new Date().setHours(0, 0, 0, 0)), new Date()]);
    var date = ref(new Date());
    var startTimeText = computed(function () {
      return times.value[0] ? formatDateTime(times.value[0]) : '';
    });
    var endTimeText = computed(function () {
      return times.value[1] ? formatDateTime(times.value[1]) : '';
    });
    var showStartPicker = ref(false);
    var showEndPicker = ref(false);
    // Vant 4 绑定字符串数组：日期 ['YYYY','MM','DD']，时间 ['HH','mm']
    var startDateArr = ref([dayjs(times.value[0]).format('YYYY'), dayjs(times.value[0]).format('MM'), dayjs(times.value[0]).format('DD')]);
    var startTimeArr = ref([dayjs(times.value[0]).format('HH'), dayjs(times.value[0]).format('mm')]);
    var endDateArr = ref([dayjs(times.value[1]).format('YYYY'), dayjs(times.value[1]).format('MM'), dayjs(times.value[1]).format('DD')]);
    var endTimeArr = ref([dayjs(times.value[1]).format('HH'), dayjs(times.value[1]).format('mm')]);
    // -------- 辅助转换函数 --------
    var dateToStringArr = function dateToStringArr(d) {
      return [String(d.getFullYear()), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')];
    };
    var timeToStringArr = function timeToStringArr(d) {
      return [String(d.getHours()).padStart(2, '0'), String(d.getMinutes()).padStart(2, '0')];
    };
    var stringArrToDate = function stringArrToDate(dateArr, timeArr) {
      var _dateArr$map = dateArr.map(Number),
        _dateArr$map2 = _slicedToArray(_dateArr$map, 3),
        year = _dateArr$map2[0],
        month = _dateArr$map2[1],
        day = _dateArr$map2[2];
      var _timeArr$map = timeArr.map(Number),
        _timeArr$map2 = _slicedToArray(_timeArr$map, 2),
        hour = _timeArr$map2[0],
        minute = _timeArr$map2[1];
      return new Date(year, month - 1, day, hour, minute);
    };
    // -------- 日期范围限制（兼容 disabledDate 属性） --------
    var today = new Date();
    var todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    var startMinDate = computed(function () {
      return props.disabledDate === 'disabledPast' ? todayStart : undefined;
    });
    var startMaxDate = computed(function () {
      if (times.value[1]) return new Date(times.value[1]);
      if (props.disabledDate === 'disabledFuture') return today;
      return undefined;
    });
    var endMinDate = computed(function () {
      if (times.value[0]) return new Date(times.value[0]);
      if (props.disabledDate === 'disabledPast') return todayStart;
      return undefined;
    });
    var endMaxDate = computed(function () {
      return props.disabledDate === 'disabledFuture' ? today : undefined;
    });
    // -------- 打开选择器（初始化当前值） --------
    var openStartPicker = function openStartPicker() {
      if (times.value[0]) {
        startDateArr.value = dateToStringArr(times.value[0]);
        startTimeArr.value = timeToStringArr(times.value[0]);
      }
      showStartPicker.value = true;
    };
    var openEndPicker = function openEndPicker() {
      if (times.value[1]) {
        endDateArr.value = dateToStringArr(times.value[1]);
        endTimeArr.value = timeToStringArr(times.value[1]);
      }
      showEndPicker.value = true;
    };
    // -------- 确认操作 --------
    var onStartConfirm = function onStartConfirm() {
      times.value[0] = stringArrToDate(startDateArr.value, startTimeArr.value);
      showStartPicker.value = false;
      confirmDate();
    };
    var onEndConfirm = function onEndConfirm() {
      times.value[1] = stringArrToDate(endDateArr.value, endTimeArr.value);
      showEndPicker.value = false;
      confirmDate();
    };
    var confirmDateDay = function confirmDateDay(value) {
      date.value = value;
      emit('confirm-date', dayjs(date.value).format('YYYY/MM/DD'));
    };
    // -------- 触发 emit --------
    var confirmDate = function confirmDate() {
      if (props.type === 3) {
        var time = dayjs(times.value[0]).format('YYYY/MM/DD HH:mm:ss') + ',' + dayjs(times.value[1]).format('YYYY/MM/DD HH:mm') + ':59';
        emit('confirm-date', time);
      } else {
        emit('confirm-date', dayjs(date.value).format('YYYY/MM/DD'));
      }
    };
    var switchBtnClick = function switchBtnClick() {
      return emit('switch');
    };
    // -------- 保留原有函数（供 type 1/2 使用） --------
    var disabledDateApi = function disabledDateApi(date) {
      if (props.disabledDate === 'disabledFuture') {
        return dayjs(date).isAfter(dayjs(), 'day');
      } else {
        return dayjs(date).isBefore(dayjs(), 'day');
      }
    };
    var disabledTimesBeforeApi = function disabledTimesBeforeApi(date) {
      return dayjs(date).isAfter(dayjs(times.value[1]), 'day');
    };
    var disabledTimesEndApi = function disabledTimesEndApi(date) {
      if (props.disabledDate === 'disabledFuture') {
        return dayjs(date).isAfter(dayjs()) || dayjs(date).isBefore(dayjs(times.value[0]), 'day');
      } else {
        return dayjs(date).isBefore(dayjs(times.value[0]), 'day');
      }
    };
    var reset = function reset() {
      date.value = new Date();
      times.value = [new Date(new Date().setHours(0, 0, 0, 0)), new Date()];
    };
    return {
      switchBtnClick: switchBtnClick,
      date: date,
      times: times,
      reset: reset,
      confirmDate: confirmDate,
      confirmDateDay: confirmDateDay,
      disabledDateApi: disabledDateApi,
      disabledTimesEndApi: disabledTimesEndApi,
      disabledTimesBeforeApi: disabledTimesBeforeApi,
      startTimeText: startTimeText,
      endTimeText: endTimeText,
      showStartPicker: showStartPicker,
      showEndPicker: showEndPicker,
      openStartPicker: openStartPicker,
      openEndPicker: openEndPicker,
      onStartConfirm: onStartConfirm,
      onEndConfirm: onEndConfirm,
      startDateArr: startDateArr,
      startTimeArr: startTimeArr,
      endDateArr: endDateArr,
      endTimeArr: endTimeArr,
      startMinDate: startMinDate,
      startMaxDate: startMaxDate,
      endMinDate: endMinDate,
      endMaxDate: endMaxDate
    };
  }
});